





















import { emailRule } from "@/lib/rules/contactRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import { BillingProfile, IBillingProfile } from "@/models/banking-information.entity";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {},
  filters: {}
})
export default class BillingProfileForm extends Vue {
  @Prop({ default: new BillingProfile() })
  value!: IBillingProfile;

  get required() {
    return [requiredRule()];
  }

  get emailRule() {
    return [emailRule(), requiredRule()];
  }
}
